module.exports = __webpack_public_path__ + "static/img/unselected.2be2a691.svg";